var _circle, _mask, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCensorship(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 18.9,
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 28,
    height: 7,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 28,
    height: 7,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2.4,
    mask: "url(#path-2-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensorship);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIxOS41IiBjeT0iMTkuNSIgcj0iMTguOSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS4yIi8+PG1hc2sgaWQ9InBhdGgtMi1pbnNpZGUtMSIgZmlsbD0iI2ZmZiI+PHJlY3QgeD0iNiIgeT0iMTYiIHdpZHRoPSIyOCIgaGVpZ2h0PSI3IiByeD0iMSIvPjwvbWFzaz48cmVjdCB4PSI2IiB5PSIxNiIgd2lkdGg9IjI4IiBoZWlnaHQ9IjciIHJ4PSIxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyLjQiIG1hc2s9InVybCgjcGF0aC0yLWluc2lkZS0xKSIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };